import { MapModelIdToModel } from "../utils";

export type CaptionModel = MapModelIdToModel<"caption">;
export type IntegrationCategoryModel = MapModelIdToModel<"integrationCategory">;
export type LinkButtonThemeModel = MapModelIdToModel<"linkButtonTheme">;
export type PageModel = MapModelIdToModel<"page">;
export type RouteModel = MapModelIdToModel<"route">;
export type TrelloTemplateModel = MapModelIdToModel<"trelloTemplate">;
export type UiAccordionItemModel = MapModelIdToModel<"uiAccordionItem">;
export type UiAccordionModel = MapModelIdToModel<"uiAccordion">;
export type UiAddToSlackSectionModel = MapModelIdToModel<"uiAddToSlackSection">;
export type UiAnimatedHeroSectionModel =
    MapModelIdToModel<"uiAnimatedHeroSection">;
export type UiBlockModel = MapModelIdToModel<"uiBlock">;
export type UiButtonModel = MapModelIdToModel<"uiButton">;
export type UiCalloutModel = MapModelIdToModel<"uiCallout">;
export type UiCaptionModel = MapModelIdToModel<"uiCaption">;
export type UiCardModel = MapModelIdToModel<"uiCard">;
export type UiCarouselModel = MapModelIdToModel<"uiCarousel">;
export type UiColumnModel = MapModelIdToModel<"uiColumn">;
export type UiContactFormModel = MapModelIdToModel<"uiContactForm">;
export type UiDownloadButtonModel = MapModelIdToModel<"uiDownloadButton">;
export type UiEmailSignupModel = MapModelIdToModel<"uiEmailSignup">;
export type UiFeatureSectionModel = MapModelIdToModel<"uiFeatureSection">;
export type UiFooterNavBasicModel = MapModelIdToModel<"uiFooterNavBasic">;
export type UiFooterNavModel = MapModelIdToModel<"uiFooterNav">;
export type UiGuideChapterModel = MapModelIdToModel<"uiGuideChapter">;
export type UiGuideModel = MapModelIdToModel<"uiGuide">;
export type UiHeaderNavModel = MapModelIdToModel<"uiHeaderNav">;
export type UiHeaderNavTabModel = MapModelIdToModel<"uiHeaderNavTab">;
export type UiHeadingModel = MapModelIdToModel<"uiHeading">;
export type UiIconModel = MapModelIdToModel<"uiIcon">;
export type UiImageModel = MapModelIdToModel<"uiImage">;
export type UiImageSetModel = MapModelIdToModel<"uiImageSet">;
export type UiIntegrationModel = MapModelIdToModel<"uiIntegration">;
export type UiIntegrationSectionModel =
    MapModelIdToModel<"uiIntegrationSection">;
export type UiLinkBlockModel = MapModelIdToModel<"uiLinkBlock">;
export type UiLinkModel = MapModelIdToModel<"uiLink">;
export type UiListCarouselModel = MapModelIdToModel<"uiListCarousel">;
export type UiLoginContainerModel = MapModelIdToModel<"uiLoginContainer">;
export type UiLoginSignupFormModel = MapModelIdToModel<"uiLoginSignupForm">;
export type UiMarkdownModel = MapModelIdToModel<"uiMarkdown">;
export type UiMarketoFormModel = MapModelIdToModel<"uiMarketoForm">;
export type UiModalModel = MapModelIdToModel<"uiModal">;
export type UiNavBannerModel = MapModelIdToModel<"uiNavBanner">;
export type UiNavBlogArticleModel = MapModelIdToModel<"uiNavBlogArticle">;
export type UiNavImagesModel = MapModelIdToModel<"uiNavImages">;
export type UiNavLinkModel = MapModelIdToModel<"uiNavLink">;
export type UiPowerUpModel = MapModelIdToModel<"uiPowerUp">;
export type UiPricingCalculatorModel = MapModelIdToModel<"uiPricingCalculator">;
export type UiPricingGridModel = MapModelIdToModel<"uiPricingGrid">;
export type UiPricingPlanModel = MapModelIdToModel<"uiPricingPlan">;
export type UiPricingComparisonRowModel =
    MapModelIdToModel<"uiPricingComparisonRow">;
export type UiPricingComparisonTableModel =
    MapModelIdToModel<"uiPricingComparisonTable">;
export type UiPricingComparisonValueModel =
    MapModelIdToModel<"uiPricingComparisonValue">;
export type UiQuoteModel = MapModelIdToModel<"uiQuote">;
export type UiRecommendShareModel = MapModelIdToModel<"uiRecommendShare">;
export type UiRotatingImagesModel = MapModelIdToModel<"uiRotatingImages">;
export type UiRotatingItemsModel = MapModelIdToModel<"uiRotatingItems">;
export type UiSectionModel = MapModelIdToModel<"uiSection">;
export type UiSectionGroupModel = MapModelIdToModel<"uiSectionGroup">;
export type UiSocialLoginSignupButtonModel =
    MapModelIdToModel<"uiSocialLoginSignupButton">;
export type UiSocialProofModel = MapModelIdToModel<"uiSocialProof">;
export type UiSocialShareModel = MapModelIdToModel<"uiSocialShare">;
export type UiSpacerModel = MapModelIdToModel<"uiSpacer">;
export type UiSplitSectionModel = MapModelIdToModel<"uiSplitSection">;
export type UiStackModel = MapModelIdToModel<"uiStack">;
export type UiStatuspageModel = MapModelIdToModel<"uiStatuspage">;
export type UiStorylineModel = MapModelIdToModel<"uiStoryline">;
export type UiTabModel = MapModelIdToModel<"uiTab">;
export type UiTabPanelModel = MapModelIdToModel<"uiTabPanel">;
export type UiTemplateGalleryModel = MapModelIdToModel<"uiTemplateGallery">;
export type UiTextBlockModel = MapModelIdToModel<"uiTextBlock">;
export type UiTooltipModel = MapModelIdToModel<"uiTooltip">;
export type UiTrelloBoardModel = MapModelIdToModel<"uiTrelloBoard">;
export type UiTrelloCardModel = MapModelIdToModel<"uiTrelloCard">;
export type UiTrelloListModel = MapModelIdToModel<"uiTrelloList">;
export type UiValuePropModel = MapModelIdToModel<"uiValueProp">;
export type UiVariationContainerModel =
    MapModelIdToModel<"uiVariationContainer">;
export type UiVideoModel = MapModelIdToModel<"uiVideo">;
export type UiVideoPlayerModel = MapModelIdToModel<"uiVideoPlayer">;
export type UiWebinarLinkModel = MapModelIdToModel<"uiWebinarLink">;
export type UiWorkspacePickerModel = MapModelIdToModel<"uiWorkspacePicker">;
export type VariationItemModel = MapModelIdToModel<"variationItem">;
